var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("UiButtonMessage", {
        attrs: { label: "add gray", buttonClass: "customAdd" },
        on: { click: _vm.showModal },
      }),
      _vm.modalShown
        ? _c(
            "AddEmployeeModal",
            {
              attrs: { title: "Add Contractor", saveDisabled: !_vm.isSelected },
              on: { close: _vm.closeModal, add: _vm.addContractorToManagers },
            },
            [
              _c("ContractorsMultiselect", {
                attrs: {
                  contractorsConditions: _vm.conditions,
                  withEmailSearch: "",
                },
                model: {
                  value: _vm.selectedContractorsIds,
                  callback: function ($$v) {
                    _vm.selectedContractorsIds = $$v
                  },
                  expression: "selectedContractorsIds",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }